var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.charge_area_data)?_c('dv-scroll-board',{staticStyle:{"height":"28vh"},attrs:{"config":_vm.charge_area_data}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }